
<tar-dialog [key]="DialogKeys.Logout"></tar-dialog>
  